const PREFIX = 'flags'

export function setFlag (
  name: string,
  value: string | number | boolean,
  prefix: string = PREFIX
): void {
  localStorage.setItem(`${prefix}.${name}`, String(value))
}

export function getFlag (
  name: string,
  defaultValue?: null,
  prefix?: string
): string | boolean | null
export function getFlag (
  name: string,
  defaultValue: boolean,
  prefix?: string
): boolean | string
export function getFlag<T extends Record<string, unknown>> (
  name: string,
  defaultValue: T,
  prefix?: string
): T | string | boolean
export function getFlag (
  name: string,
  defaultValue: unknown = null,
  prefix: string = PREFIX
): unknown {
  const value = localStorage.getItem(`${prefix}.${name}`)
  return (value === null || value === undefined)
    ? defaultValue
    : (value === 'true')
      ? true
      : (value === 'false')
        ? false
        : value
}

export function removeFlag (name: string, prefix: string = PREFIX): void {
  localStorage.removeItem(`${prefix}.${name}`)
}

const flags = {
  setFlag,
  getFlag,
  removeFlag,
}

export default flags

if (!window.booksy) {
  window.booksy = {}
}
window.booksy.getFlag = getFlag
window.booksy.setFlag = setFlag
